import { render, staticRenderFns } from "./recess-link.global.vue?vue&type=template&id=9e1e4bae&"
import script from "./recess-link.global.vue?vue&type=script&lang=js&"
export * from "./recess-link.global.vue?vue&type=script&lang=js&"
import style0 from "./recess-link.global.vue?vue&type=style&index=0&id=9e1e4bae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports